export const FETCH_PAYMENTS_START = "FETCH_PAYMENTS_START";
export const FETCH_PAYMENTS_SUCCESS = "FETCH_PAYMENTS_SUCCESS";
export const FETCH_PAYMENTS_FAIL = "FETCH_PAYMENTS_FAIL";

export const SET_PAYMENTS_SOURCE = "SET_PAYMENTS_SOURCE";
export const SET_PAYMENTS_SEARCH_TEXT = "SET_PAYMENTS_SEARCH_TEXT";
export const SET_PAYMENTS_STATUSES = "SET_PAYMENTS_STATUSES";
export const SET_PAYMENTS_CURRENT_PAGE = "SET_PAYMENTS_CURRENT_PAGE";
export const SET_PAYMENTS_PAGE_SIZE = "SET_PAYMENTS_PAGE_SIZE";

export const RESET_PAYMENTS = "RESET_PAYMENTS";
